<template>
  <q-btn
    title="Выгрузка excel"
    :loading="loading"
    :disable="loading || disabled"
    class="print"
    @click="$emit('click')"
  >
    <i class="material-icons">print</i>
    <span class="title">Выгрузка <br />в Excel</span>
  </q-btn>
</template>

<script>
export default {
  name: "UploadExcelBtn",
  emits: ["click"],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.print {
  background: #21830b !important;
  color: #fff;
  max-height: 100% !important;
  min-height: 33px !important;
}
.title {
  margin-left: 5px;
  font-size: 10px;
  line-height: 12px;
}
</style>